module.exports = __webpack_public_path__ + "static/media/12.964ef0a3.png";